import { baseApi } from '@shared/api/baseApi'

export interface LinkEmailSendCodeResponse {
  will_merge: boolean
  next_resend: string
  expired_at: string
  code: string | null
}

export interface LinkEmailVerifyCodeResponse {
  user_id: number
  merged: boolean
  merge_details: Record<string, unknown> | null
}

const normalize = (e: string) => e.trim().toLowerCase()

export const linkEmailSendCode = async (email: string): Promise<LinkEmailSendCodeResponse> => {
  const { data } = await baseApi.post<LinkEmailSendCodeResponse>(
    '/api/user/link-email/send-code',
    { email: normalize(email) }
  )
  return data
}

export const linkEmailVerifyCode = async (email: string, code: string): Promise<LinkEmailVerifyCodeResponse> => {
  const { data } = await baseApi.post<LinkEmailVerifyCodeResponse>(
    '/api/user/link-email/verify-code',
    { email: normalize(email), code }
  )
  return data
}
